import {
  KpiFooterStats,
  KpiStatus,
  KpiStatusType,
  KpiTitle,
  KpiVM,
} from 'src/app/dashboards/dashboard-shared/kpi/kpi-stats/kpi-view-model';
import { Kpi, KpiMetric, KpiStat } from 'src/app/shared/flight-log-api/kpi/kpi.model';

export class FaaFlightTimeKpis {
  private decimalPlace = 2;

  public static create(kpiMetric: KpiMetric) {
    return new FaaFlightTimeKpis(kpiMetric);
  }

  constructor(private kpiMetric: KpiMetric) {}

  public createKpi(granularity: string, windowSize: number) {
    return (): KpiVM | undefined => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const kpi: Kpi = this.getKpi(granularity, windowSize)!;
      switch (granularity + windowSize) {
        case 'Hour24': {
          return this.applyRule(this.kpiMetric, kpi, 5);
        }
        case 'Quarter1': {
          return this.applyRule(this.kpiMetric, kpi, 400);
        }
        case 'Quarter2': {
          return this.applyRule(this.kpiMetric, kpi, 600);
        }
        case 'Year1': {
          return this.applyRule(this.kpiMetric, kpi, 1200);
        }
      }
    };
  }

  private applyRule(kpiMetric: KpiMetric, kpi: Kpi, warningThreshold: number): KpiVM {
    const curKpiStat = this.getCurrentKpiStat(kpi);
    // default to OK
    let status = KpiStatus.ok;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (curKpiStat.value >= kpi.maximum!) {
      status = KpiStatus.danger;
    } else if (curKpiStat.value >= warningThreshold) {
      status = KpiStatus.warn;
    }
    return this.createKpiVm(kpiMetric, kpi, curKpiStat, status);
  }

  private getKpi(granularity: string, windowSize: number) {
    return this.kpiMetric.kpis.find(
      (kpi) => kpi.granularity === granularity && kpi.windowSize === windowSize,
    );
  }

  private getCurrentKpiStat(kpi: Kpi): KpiStat {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return kpi.data.find((stat) => stat.isCurrentPeriod != null && stat.isCurrentPeriod)!;
  }

  private createKpiVm(
    kpiMetric: KpiMetric,
    kpi: Kpi,
    currentKpiStat: KpiStat,
    status: KpiStatusType,
  ): KpiVM {
    const hrsRemaining =
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      kpi.maximum! - currentKpiStat.value > 0 ? kpi.maximum! - currentKpiStat.value : 0;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const progress = Math.floor((currentKpiStat.value / kpi.maximum!) * 100);
    return new KpiVM(
      KpiTitle.create(`${kpi.windowSize} ${kpi.granularity}`, `${kpiMetric.name}`),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      `${currentKpiStat.value.toFixed(this.decimalPlace)} / ${kpi.maximum!.toFixed(
        this.decimalPlace,
      )} hours`,
      {
        stat1: KpiFooterStats.create(hrsRemaining.toFixed(this.decimalPlace), ' hours remaining'),
      },
      status,
      progress > 100 ? 100 : progress,
    );
  }
}
